import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-plano-acao-monitor-cancelar',
  templateUrl: './plano-acao-monitor-cancelar.component.html',
  styleUrls: ['./plano-acao-monitor-cancelar.component.scss']
})
export class PlanoAcaoMonitorCancelarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
